import { Close } from "@mui/icons-material";
import { ClickAwayListener, TooltipProps } from "@mui/material";
import { FC, ReactNode, useState } from "react";
import { COLORS } from "../../../styles/constants.style";
import { MuiBox } from "../../box/MuiBox";
import { ErrorInfoIcon } from "../../errorInfoIcon/ErrorInfoIcon";
import { MuiTypography } from "../../typography/MuiTypography";
import { MuiStyledTooltip } from "../MuiToolTip.style";
import { MuiInfoToolTipWrapper } from "./MuiInfoToolTip.style";

type MuiInfoToolTipProps = {
  message: string | ReactNode;
  placement?: TooltipProps["placement"];
  isRemoveCloseIcon?: boolean;
  className?: string;
  shouldDisableInfoIcon?: boolean;
  tooltipChildren?: ReactNode;
  errorIconClassName?: string;
  headerTitle?: string;
};

export const MuiInfoToolTip: FC<MuiInfoToolTipProps> = ({
  message,
  placement = "bottom",
  isRemoveCloseIcon = false,
  className,
  shouldDisableInfoIcon = false,
  tooltipChildren,
  errorIconClassName,
  headerTitle,
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTipClose = () => {
    if (showToolTip) {
      setShowToolTip(false);
    }
  };

  const toggleToolTip = () => {
    if (shouldDisableInfoIcon) {
      return;
    }
    setShowToolTip(true);
  };

  return (
    <ClickAwayListener onClickAway={() => setShowToolTip(false)}>
      <MuiBox>
        <MuiInfoToolTipWrapper className={className}>
          <MuiStyledTooltip
            toolTipBgColor={COLORS.cirrus_black1}
            textColor={COLORS.cirrus_black}
            arrowBgColor={COLORS.cirrus_black6}
            borderWidth={"1px"}
            placement={placement}
            role="tooltip"
            title={
              <>
                {!isRemoveCloseIcon ? (
                  <Close onClick={handleToolTipClose} />
                ) : null}
                {headerTitle && (
                  <MuiTypography className="header-title" variant={"h3"}>
                    {headerTitle}
                  </MuiTypography>
                )}
                <MuiTypography
                  {...(headerTitle && { className: "header-title-margin" })}
                  variant={"h3"}
                >
                  {message}
                </MuiTypography>
                {tooltipChildren}
              </>
            }
            open={showToolTip}
          >
            <ErrorInfoIcon
              shouldDisableInfoIcon={shouldDisableInfoIcon}
              onToggleToolTip={toggleToolTip}
              errorIconClassName={errorIconClassName}
            />
          </MuiStyledTooltip>
        </MuiInfoToolTipWrapper>
      </MuiBox>
    </ClickAwayListener>
  );
};
